/* eslint-disable */
import { Chip, List, ListItem, ListItemText, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import MuiLink from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import BusinessIcon from '@material-ui/icons/Business';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FolderIcon from '@material-ui/icons/Folder';
import GradientIcon from '@material-ui/icons/Gradient';
import PhoneIcon from '@material-ui/icons/Phone';
import RoomIcon from '@material-ui/icons/Room';
import TimerIcon from '@material-ui/icons/Timer';
import * as Sentry from '@sentry/browser';
import cn from 'classnames';
import round from 'lodash/round';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { ORDER_API_DATE_FORMAT, ORDER_STATUS_COMPLETED, ORDER_STATUS_NEW, ORDER_STATUS_TO_BE_CONFIRMED, ORDER_STATUS_CANCELLED  } from '../../Constants/Order/Order.constants';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import { createOrderConcreteDeliveriesPageLink } from '../../Pages/OrderConcreteDeliveries/OrderConcreteDeliveries.page.route';
import { createPlaceOrderPageLink } from '../../Pages/PlaceOrder/PlaceOrder.page.route';
import { ORDER_DETAILS_POLLING_INTERVAL } from '../../Services/Order/Order.service.constants';
import ordersActionCreators from '../../State/Store/Orders/Orders.actions';
import orderConfirmationDoneSelector from '../../State/Store/Orders/Selectors/OrderConfirmationDone.selector';
import orderConfirmationErrorSelector from '../../State/Store/Orders/Selectors/OrderConfirmationError.selector';
import orderConfirmedSelector from '../../State/Store/Orders/Selectors/OrderConfirmed.selector';
import orderItemSelector from '../../State/Store/Orders/Selectors/OrderItem.selector';
import ordersSelectedLoadingSelector from '../../State/Store/Orders/Selectors/OrderSelectedLoading.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_DOCKET_DETAILS_DIALOG_OPEN,
  UI_FAB_PLACE_ORDER_CLICK,
  UI_ORDER_DETAILS_ACCOUNT_CHIP_CLICK,
  UI_ORDER_DETAILS_PROJECT_CHIP_CLICK,
} from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import formatWithTime from '../../Support/DateTime/FormatWithTime/DateTimeFormatWithTime.support';
import envGet from '../../Support/Env/Get/EnvGet.support';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import AccountDetails from '../AccountDetails/AccountDetails.component';
import DeliveryDocketModal from '../DeliveryDocket/DeliveryDocketModal.component';
import Footer from '../Footer/Footer.component';
import I18n from '../I18n/I18n.component';
import KeyValueDateTimeField from '../KeyValueDateTimeField/KeyValueDateTimeField.component';
import KeyValueMultiLineField from '../KeyValueMultiLineField/KeyValueMultiLineField.component';
import KeyValuePairs from '../KeyValuePairs/KeyValuePairs.component';
import OrderActions from '../OrderActions/OrderActions.component';
import OrderConfirmationDialog from '../OrderConfirmationDialog/OrderConfirmationDialog.component';
import OrderConfirmationMessage from '../OrderConfirmationMessage/OrderConfirmationMessage.component';
import OrderDetailsVolumeField from '../OrderDetailsVolumeField/OrderDetailsVolumeField.component';
import OrderProgress from '../OrderProgress/OrderProgress.component';
import OrderQuantity from '../OrderQuantity/OrderQuantity.component';
import SpeedDialWrapperComponent from '../SpeedDialWrapper/SpeedDialWrapper.component';
import Spinner from '../Spinner/Spinner.component';
import OrderDetailsPropTypes from './OrderDetails.component.props';
import orderDetailsStyles from './OrderDetails.component.styles';
import StyledHourglassFullIconComponent from '../OrderDetailsHeader/StyledHourglassFullIcon.component';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';
import isToday from 'date-fns/is_today';

const FEATURE_TOGGLE_FAB_BUTTONS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_FAB_BUTTONS` }) === `true`
const REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS` }) === `true`

/**
 * OrderDetailsComponent
 * @export
 * @class OrderDetailsComponent
 * @extends {React.Component<OrderDetailsComponentComposedProps, OrderDetailsComponentState>}
 */
export class OrderDetailsComponent extends React.Component {
  preserveScrollRef = React.createRef();

  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderDetailsComponentProps>}
   * @memberof OrderDetailsComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderDetails`}
   * @memberof OrderDetailsComponent
   */
  static displayName = `OrderDetails`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderDetailsComponent
   */
  static propTypes = OrderDetailsPropTypes;

  /**
   * Data specific to the `<OrderDetailsComponent />` instance
   * @type {OrderDetailsComponentState}
   * @memberof OrderDetailsComponent
   */
  state = {
    i18nSection: null,
  };

  /**
   * The polling interval id
   * @type {number}
   * @memberof OrderDetailsComponent
   */
  pollingId = null;


  ORDER_DETAILS_DATE_TIME_FIELDS_MAPPING = [
    [
      `summary.startTime`,
      `OrderService.OrderDetails.Labels.DateAndTime`,
      ({ InputProps, label, value }) => (
        <KeyValueDateTimeField formatString="h:mm a, ddd D MMM YYYY" GridItemProps={{ sm: 5 }} InputProps={InputProps} label={label} value={value} />
      ),
    ],
    [`details.deliveryAddress`, `OrderService.OrderDetails.Labels.DeliveryAddress`],
  ];


  ORDER_DETAILS_FIELDS_MAPPING = [
    [
      `details.cancelledAt`,
      `OrderService.OrderDetails.Labels.OrderCancelled`,
      ({ InputProps, label, value }) => <KeyValueDateTimeField formatString="h:mm a, ddd D MMM YYYY" InputProps={InputProps} label={label} value={value} />,
    ],
    [`details.product`, `OrderService.OrderDetails.Labels.ProductDetails`],
  ];

  ORDER_DETAILS_CODE_FIELDS_MAPPING = [
    [`details.po`, `OrderService.OrderDetails.Labels.PurchaseOrder`],
    [`details.projectName`, `OrderService.OrderDetails.Labels.ProjectName`],
  ];


  ORDER_DETAILS_DELIVERY_FIELDS_MAPPING = [
    [
      `details.qty`,
      `OrderService.OrderDetails.Labels.VolumeOnOrder`,
      ({ InputProps, label, value }) => <OrderDetailsVolumeField InputProps={InputProps} label={label} value={value} />,
    ],
    [`details.spacing`, `OrderService.OrderDetails.Labels.DeliverySpacing`],
  ];


  ORDER_DETAILS_SECONDARY_FIELDS_MAPPING = [
    [
      `details.instructions`,
      `OrderService.OrderDetails.Labels.SpecialInstructions`,
      ({ InputProps, label, value }) => <KeyValueMultiLineField InputProps={InputProps} label={label} value={value} />,
    ],
    [`details.siteTel`, `OrderService.OrderDetails.Labels.SiteContactMobile`],
  ];

  /**
   * component Will Unmount
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  componentWillUnmount() {
    clearInterval(this.pollingId);
  }

  /**
   * component Did Mount
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  async componentDidMount() {
    const { currentOrder, services } = this.props;
    this.setPolling();
    // we need to send to backend format 1234:super/standard
    const billToAccounts = services.authService.getGroups();
    const billTo = billToAccounts.find((billToAccount) => {
      return helpers.getNumberFromBillTo(billToAccount) === currentOrder.summary.customerCode.trim();
    });
    this.setState({
      accountLoading: true,
      completedDeliveryLoading: true,
    });
    let orderDetails = null;

    const promises = [services.userService.getUserAccount(billTo)];
    if (this.shouldDisplayDockets()) {
      promises.push(services.orderService.getCompletedDelivery(currentOrder.orderKey));
    }
    orderDetails = await Promise.all(promises);

    // this is fix for CX-3750 where backend sometimes returns JSON object as a string. This should be fixed on backend however was taking too long and we had no solution, hence this frontend fix below
    if (orderDetails && orderDetails[0] && orderDetails[0].account && typeof orderDetails[0].account[0] === `string`) {
      try {
        orderDetails[0].account[0] = JSON.parse(orderDetails[0].account[0]);
        // send info to sentry so we know backend returned string again instead of object
        Sentry.captureMessage(`Backend returned account details as string instead of object and it was parse succesfully`);
      } catch (ex) {
        Sentry.captureMessage(
          `Backend returned account details as string instead of object and this string could not be parsed: ${orderDetails[0].account[0]}`,
        );
      }
    }
    // ##### end of fix for CX-3750

    this.setState({
      account:
        orderDetails && orderDetails[0]
          ? {
              ...orderDetails[0].account[0],
              users: orderDetails[0].users,
            }
          : null,
      accountLoading: false,
      completedDelivery: orderDetails && orderDetails[1] ? orderDetails[1] : null,
      completedDeliveryLoading: false,
    });
  }

  /**
   * componentDidUpdate
   * @param {any} prevProps prevProps
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  componentDidUpdate(prevProps) {
    const { orderConfirmationDone: prevOrderConfirmationDone } = prevProps;
    const { orderConfirmed, orderConfirmationDone, selectedOrderLoading } = this.props;
    const confirmStatusChanged = prevOrderConfirmationDone !== orderConfirmationDone;
    if (!confirmStatusChanged) {
      return;
    }
    const isInitial = orderConfirmed === null && orderConfirmationDone === null;
    if (isInitial) {
      return;
    }
    const processing = orderConfirmed === null && orderConfirmationDone === false;
    if (!processing && !selectedOrderLoading) {
      clearInterval(this.pollingId);
      this.setPolling();
    }
  }

  /**
   * Set confirm dialog to close
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  onCloseConfirmDialog = () => {
    this.setState({ openConfirmDialog: false });
  };

  /**
   * Set polling to call order details
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  setPolling = () => {
    this.requestOrderDetails();
    this.pollingId = setInterval(() => {
      this.requestOrderDetails();
    }, ORDER_DETAILS_POLLING_INTERVAL);
  };

  /**
   * Request for order details
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  requestOrderDetails() {
    const { services } = this.props;
    if (!services.authService.isAuthenticated()) {
      return;
    }
    const { currentOrder, actions } = this.props;
    const { summary } = currentOrder || {};
    if (!summary) {
      return;
    }
    const { startTime, orderCode, orderLine } = summary;
    const requestPayload = {
      date: dateOnly(startTime, ORDER_API_DATE_FORMAT),
      orderCode,
      orderLine,
    };
    actions.ordersFindById(requestPayload);
  }

  /**
   * renderLoader
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderLoader() {
    const { classes, selectedOrderLoading } = this.props;
    return (
      <Fade in={selectedOrderLoading}>
        <LinearProgress className={classes.loader} />
      </Fade>
    );
  }

  /**
   * renderError
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderError() {
    const { classes } = this.props;
    return (
      <Grid alignContent="center" alignItems="center" classes={{ container: classes.errorMessageContainer }} container justify="center">
        <ErrorOutlineIcon className={classes.errorIcon} />
        <I18n>OrderService.OrderDetails.ErrorMessage</I18n>
      </Grid>
    );
  }

  /**
   * Renders the primary details section
   * @param {Order} currentOrder The current order
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderPrimaryDetailsSection = (currentOrder) => {
    const { classes } = this.props;
    return (
      <Paper classes={{ root: classes.section }}>
        <Grid container spacing={1}>
          <Grid item sm={9} xs={12}>
            <KeyValuePairs
              fieldsMapping={this.ORDER_DETAILS_DATE_TIME_FIELDS_MAPPING}
              GridContainerProps={{ classes: { container: classes.dateTimeContainer }, direction: `row` }}
              keyValuePairs={currentOrder}
            />
            <KeyValuePairs fieldsMapping={this.ORDER_DETAILS_FIELDS_MAPPING} keyValuePairs={currentOrder} />
          </Grid>
          <Grid item sm xs>
            <KeyValuePairs fieldsMapping={this.ORDER_DETAILS_CODE_FIELDS_MAPPING} keyValuePairs={currentOrder} />
          </Grid>
        </Grid>
      </Paper>
    );
  };

  /**
   * Renders the delivery details section
   * @param {Order} currentOrder The current order
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderDeliveryDetailsSection = (currentOrder) => {
    const { details, summary } = currentOrder;
    if (!summary) {
      return null;
    }
    if (!details) {
      return null;
    }
    const { status } = summary;
    const { cdLink, qty } = details;
    const quantity = qty && {
      dispatchedAmount: qty.dispatched,
      orderedAmount: qty.ordered,
      unitOfMeasure: qty.uom,
    };
    const { classes, match, width } = this.props;
    const { orderId } = match.params;
    const link = createOrderConcreteDeliveriesPageLink({ orderId });
    return (
      <Paper classes={{ root: classes.section }}>
        <Grid container spacing={1}>
          <Grid item sm={3} xs={12}>
            <KeyValuePairs fieldsMapping={this.ORDER_DETAILS_DELIVERY_FIELDS_MAPPING} keyValuePairs={currentOrder} />
          </Grid>
          <Grid container direction="column" item justify="space-between" sm spacing={1} xs={12}>
            <Grid item>
              <OrderQuantity quantity={quantity} status={status} />
            </Grid>
            {cdLink && (
              <Grid container item justify="flex-end">
                <Button color="secondary" component={Link} fullWidth={isWidthDown(`xs`, width)} to={link} variant="contained">
                  <Grid container justify="space-between">
                    <I18n textTransform="none" variant="subtitle2">
                      OrderService.ConcreteDeliveriesButtonLabel
                    </I18n>
                    <ChevronRightIcon />
                  </Grid>
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
  };

  /**
   * Renders the secondary details section
   * @param {Order} currentOrder The current order
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderSecondaryDetailsSection = (currentOrder) => {
    const { details } = currentOrder;
    if (!details) {
      return null;
    }
    const { instructions, siteTel } = details;
    if (!instructions && !siteTel) {
      return null;
    }
    const { classes } = this.props;
    return (
      <Paper classes={{ root: classes.section }}>
        <KeyValuePairs fieldsMapping={this.ORDER_DETAILS_SECONDARY_FIELDS_MAPPING} GridContainerProps={{ direction: `row` }} keyValuePairs={currentOrder} />
      </Paper>
    );
  };

  /**
   * Renders order progress section
   * @param {Order} currentOrder The current order
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderOrderProgressSection = (currentOrder) => {
    const { match } = this.props;
    const { orderId } = match.params;
    return <OrderProgress orderId={orderId} />;
  };

  /**
   * Renders the call to action section
   * @param {Order} currentOrder The current order
   * @returns {React.Component} component
   * @memberof OrderDetailsComponent
   */
  renderCallToActionSection = (currentOrder) => {
    if (!currentOrder) {
      return null;
    }
    const { details, summary } = currentOrder;
    return <OrderActions details={details} summary={summary} />;
  };

  /**
   * Returns if dockets information should be displayed
   * @returns {boolean} true if order in a past and completed
   * @memberof OrderDetailsComponent
   */
  shouldDisplayDockets = () => {
    const { currentOrder } = this.props;
    if (
      currentOrder &&
      currentOrder.summary.status === ORDER_STATUS_COMPLETED &&
      moment(formatWithTime(currentOrder.summary.startTime, `MM/DD/YYYY`)).isBefore(moment().startOf(`day`))
    ) {
      return true;
    }
    return false;
  };

  /**
   * Returns the unit of measure
   * @returns {string} The unit of measure
   * @memberof OrderDetailsComponent
   */
  getUnitOfMeasure = () => {
    const { currentOrder } = this.props;
    const { details } = currentOrder;
    const { qty } = details || {};
    const { uom } = qty || {};
    return toDisplayUnit(uom);
  };

  /**
   * Opens modal
   * @param {string} ticketCode Ticket code of the docket
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  openDocketDetails = async (ticketCode) => {
    if (!REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS) {
      return;
    }
    const { userInfo, actions, currentOrder, services } = this.props;
    const { id: userId } = userInfo;
    const { summary } = currentOrder || {};
    if (!summary) {
      return;
    }

    const { startTime, orderLine } = summary;
    const date = dateOnly(startTime, ORDER_API_DATE_FORMAT);
    const orderCode = summary.orderCode.trim();

    const requestPayload = {
      date,
      orderCode,
      orderLine,
      ticketCode,
    };
    this.setState({
      ticketCode,
    });
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketDetailsModalOpen`,
        },
      },
      type: UI_DOCKET_DETAILS_DIALOG_OPEN,
    });

    this.setState({ docketId: ticketCode });
  };

  /**
   * Closes modal
   * @returns {void} void
   * @memberof OrderDetailsComponent
   */
  closeDocketDetails = () => {
    this.setState({ docketId: null });
    return;
  };

  /**
   * Applies clicked filter and hides modal
   * @param {boolean} isAccount is account or project
   * @returns {void} void
   * @memberof OrderSummaryComponent
   */
  goToOrders = (isAccount) => {
    const { actions, history } = this.props;
    actions.uiTriggered({
      payload: {
        data: {
          name: isAccount ? `orderDetailsAccountChipClick` : `orderDetailsProjectChipClick`,
        },
      },
      type: isAccount ? UI_ORDER_DETAILS_ACCOUNT_CHIP_CLICK : UI_ORDER_DETAILS_PROJECT_CHIP_CLICK,
    });
    history.push(`/orders`);
    return;
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderDetailsComponent />`
   * @memberof OrderDetailsComponent
   */
  render() {
    const { currentOrder, history, actions } = this.props;
    const { account, accountLoading, completedDeliveryLoading, completedDelivery, docketId, ticketCode } = this.state;
    if (!currentOrder) {
      return null;
    }
    const { details, error, summary } = currentOrder;
    const { classes, entry, orderConfirmed, orderConfirmationDone, services, width } = this.props;
    const { i18nSection, openConfirmDialog } = this.state;

    const noFabLg = !FEATURE_TOGGLE_FAB_BUTTONS && isWidthUp(`lg`, width);
    const noFabMd = !FEATURE_TOGGLE_FAB_BUTTONS && isWidthDown(`md`, width);
    const processing = orderConfirmed === null && orderConfirmationDone === false;
    const shouldShowFab = FEATURE_TOGGLE_FAB_BUTTONS && details && !processing && isWidthDown(`sm`, width);
    const canConfirmOrder = !orderConfirmed && services.orderService.canConfirmOrder(entry, summary);
    const canCancelOrder = details && services.orderService.canCancelOrder(entry, summary, details);
    let accountMessage = <Spinner color="primary" />;
    let completedDeliveryMessage = <Spinner className={classes.marginBottom3unit} color="primary" />;
    const unitOfMeasure = this.getUnitOfMeasure();
    if (account) {
      accountMessage = (
        <Paper classes={{ root: classes.section }}>
          <AccountDetails account={account} />
        </Paper>
      );
    } else if (!accountLoading) {
      accountMessage = <Typography variant="body1">Account not found</Typography>;
    }
    if (completedDelivery) {
      completedDeliveryMessage = (
        <Paper classes={{ root: classes.section }}>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="h6">Delivered</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography classes={{ root: classes.deliveredTotal }} variant="body2">
                {`${round(completedDelivery.reduce((acc, d) => acc + d.concreteQuantity * 1, 0), 1).toFixed(1)}${unitOfMeasure}`}
              </Typography>
            </Grid>
          </Grid>
          <List>
            {completedDelivery.map((docketRow, i) => (
              <ListItem
                button={REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS}
                classes={{ gutters: classes.listItemGutters }}
                className={REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS && classes.cursorPointer}
                key={docketRow.ticketCode}
                onClick={() => this.openDocketDetails(docketRow.ticketCode)}
              >
                <ListItemText
                  primary={
                    <Typography className={REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS && classes.textDecorationUnderline} variant="body2">
                      {docketRow.ticketCode}
                    </Typography>
                  }
                  secondary="DOCKET"
                />
                <ListItemText
                  primary={<Typography variant="body2">{`${round(docketRow.concreteQuantity, 1).toFixed(1)}${unitOfMeasure}`}</Typography>}
                  secondary={`TRUCK ${docketRow.truckCode}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      );
    } else if (!completedDeliveryLoading) {
      completedDeliveryMessage = <Typography variant="body1">Details could not be loaded</Typography>;
    }

    const { orderLine } = summary;
    const orderCode = summary.orderCode.trim();

    /**
     * Render the DetailsItem component
     * @param {object} details icon, title and content to be rendered
     * @returns {React.Component} The rendered `<DetailsItem />`
     * @memberof OrderDetailsComponent
     */
    const DetailsItem = ({ icon, title, content, isPendingModification = false }) => {
      return (
        <Grid container>
          <Grid item xs={12}>
            <Grid container spacing={1} className={classes.detailsItemHeading} alignItems="center">
              {icon && (
                <Grid item className={classes.detailsItemIcon}>
                  {icon}
                </Grid>
              )}
              <Grid item>
                <Typography variant="subtitle2" className={classes.detailsItemHeading}>
                  {title}
                </Typography>
              </Grid>
              { isPendingModification &&
                <Grid item>
                  <StyledHourglassFullIconComponent />
                </Grid>
              }
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {content}
          </Grid>
        </Grid>
      );
    };

    /**
     * Render vertical line grid item
     * @returns {React.Component} The rendered `<VerticalGridItem />`
     * @memberof OrderDetailsComponent
     */
    const VerticalGridItem = () => {
      return (
        <Grid item>
          <div className={classes.detailsBoxItemBorder}>&nbsp;</div>
        </Grid>
      );
    };

    const hasSidebar =
    isToday(currentOrder.summary.startTime.replace(`.`, `:`)) &&
    currentOrder.summary.status !== ORDER_STATUS_TO_BE_CONFIRMED &&
    currentOrder.summary.status !== ORDER_STATUS_NEW &&
    currentOrder.summary.status !== ORDER_STATUS_CANCELLED;

    return (
      <React.Fragment>
        {docketId && (
          <DeliveryDocketModal
            currentDocket={{
              orderDate: currentOrder.orderKey.substring(0, 8),
              orderCode,
              orderLine,
              docketNumber: ticketCode,
            }}
            currentAccount={(account && account.CustomerCode) ? account.CustomerCode.trim() : ''}
            onCloseDetails={this.closeDocketDetails}
            open={!!docketId}
          />
        )}
        <Grid item>{this.renderLoader()}</Grid>


        {error && <Grid item>{this.renderError()}</Grid>}
        {currentOrder.details && (
          <div className={cn(classes.growFull, classes.detailsContainer, hasSidebar ? classes.detailsContainerWithSidebar : null)} ref={this.preserveScrollRef}>
            <Grid container item spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="overline" className={classes.marginottom3unit}>
                      Order Details
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <DetailsItem
                      icon={<GradientIcon fontSize="small" />}
                      content={
                        <React.Fragment>
                          {/* this is for multiple products be displayed */}
                          {currentOrder.details.product.map((el, i) => {
                            return (
                              <Grid container spacing={1} key={i}>
                                <Grid item xs={12}>
                                  <Typography variant="h6" className={classes.h6LineHeight}>{el.name}</Typography>
                                  <Typography variant="body2">Code: {el.code}</Typography>
                                </Grid>
                              </Grid>
                            );
                          })}
                        </React.Fragment>
                      }
                      title="Product"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={7}>
                        <DetailsItem
                          icon={<RoomIcon fontSize="small" />}
                          content={
                            <Typography
                              variant="h6"
                              className={classes.h6LineHeight}
                              data-mf-replace-inner={MFSDR}
                            >
                              {currentOrder.details.deliveryAddress}
                            </Typography>
                          }
                          title="To"
                        />
                      </Grid>
                      <Grid item xs={5}>
                        {currentOrder.details.lotNumber && (
                          <DetailsItem content={<Typography variant="body1">{currentOrder.details.lotNumber}</Typography>} title="Lot Number" />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <DetailsItem
                      icon={<TimerIcon fontSize="small" />}
                      content={
                        <React.Fragment>
                          <Typography variant="h6" className={classes.h6LineHeight}>
                            { formatWithTime(currentOrder.summary.startTime, `h:mm A`) }
                          </Typography>
                          <Typography variant="h6" className={classes.h6LineHeight}>
                            { formatWithTime(currentOrder.summary.startTime, `ddd D MMM YYYY`) }
                          </Typography>
                        </React.Fragment>
                      }
                      title="Scheduled from"
                      isPendingModification={
                        currentOrder.details.isPendingModification &&
                        currentOrder.details.modifyFields &&
                        'dateTime' in currentOrder.details.modifyFields
                      }
                    />
                  </Grid>
                  { (currentOrder.details.isPendingModification || currentOrder.details.instructions) && (
                    <Grid item xs={12}>
                      <DetailsItem
                        content={
                          <Typography variant="body2" className={classes.overflowScroll} data-mf-replace-inner={MFSDR}>
                            {currentOrder.details.instructions}
                          </Typography>
                        }
                        title="Special Instructions"
                        isPendingModification={
                          currentOrder.details.isPendingModification &&
                          currentOrder.details.modifyFields &&
                          'instructions' in currentOrder.details.modifyFields
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Grid container spacing={2} className={cn(classes.flexWrapNowrap)}>
                      <Grid item>
                        <Typography variant="subtitle2" className={classes.detailsItemHeading}>
                          Order Number
                        </Typography>
                        <Typography variant="body1">{currentOrder.summary.orderCode}</Typography>
                      </Grid>
                      <VerticalGridItem />
                      <Grid item>
                        <Typography variant="subtitle2" className={classes.detailsItemHeading}>
                          P/O Number
                        </Typography>
                        <Typography variant="body1" data-mf-replace-inner={MFSDR}>{currentOrder.details.po}</Typography>
                      </Grid>
                      <VerticalGridItem />
                      <Grid item>
                        <Typography variant="subtitle2" className={classes.detailsItemHeading}>
                          Site Contact Mobile
                          {
                            currentOrder.details.isPendingModification &&
                            currentOrder.details.modifyFields &&
                            'siteContactPhoneNumber' in currentOrder.details.modifyFields &&
                            <div className={cn(classes.marginLeft1unit, classes.displayInlineBlock)}>
                              <StyledHourglassFullIconComponent />
                            </div>
                          }
                        </Typography>
                        <Typography variant="body1" data-mf-replace-inner={MFSDR}>{currentOrder.details.siteTel}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      {currentOrder.details.projectName && (
                        <Grid item>
                          <Grid container spacing={1}>
                            <Grid item>
                              <Typography variant="subtitle2" className={cn(classes.marginBottom1unit, classes.detailsItemHeading)}>
                                Project
                              </Typography>
                              <Chip
                                data-mf-replace-inner={MFSDR}
                                icon={<FolderIcon className={classes.colorZambezi600} />}
                                label={<div>{currentOrder.details.projectName}</div>}
                                variant="outlined"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      <Grid item>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Typography variant="subtitle2" className={cn(classes.marginBottom1unit, classes.detailsItemHeading)}>
                              Account
                            </Typography>
                            {account && <Chip icon={<BusinessIcon className={classes.colorZambezi600} />} label={account.AccountName} variant="outlined"data-mf-replace-inner={MFSDR} />}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <hr className={cn(classes.marginTop3unit, classes.keyLine)} />
              </Grid>
              <Grid item xs={12} md={6} className={classes.marginBottom3unit}>
                <Typography variant="overline" className={classes.marginBottom3unit} component="div">
                  Delivery Progress
                </Typography>
                {this.shouldDisplayDockets() ? completedDeliveryMessage : this.renderOrderProgressSection(currentOrder)}
              </Grid>
            </Grid>
          </div>
        )}
        {noFabMd && (
          <Grid classes={{ item: classes.section }} item>
            {this.renderCallToActionSection(currentOrder)}
          </Grid>
        )}
        {shouldShowFab && summary.status !== ORDER_STATUS_NEW && (
          <SpeedDialWrapperComponent
            icon={<AddIcon />}
            name="OrderDetailsSpeedDial"
            options={[
              {
                icon: (
                  <MuiLink color="inherit" href={`tel:${details.boralTel}`}>
                    <PhoneIcon />
                  </MuiLink>
                ),
                // Workaround for this issue: https://github.com/mui-org/material-ui/issues/13522
                onClick: () => window.open(`tel:${details.boralTel}`, `_self`),
                tooltip: {
                  i18n: {
                    data: { contactNumber: isWidthDown(`xs`, width) ? `` : details.boralTel },
                    key: `OrderService.CallBoral`,
                  },
                },
              },
              // {
              //   icon: <DeleteForeverIcon />,
              //   onClick: () => {
              //     this.setState({
              //       i18nSection: `OrderCancellation`,
              //       openConfirmDialog: true,
              //     });
              //   },
              //   show: canCancelOrder,
              //   tooltip: {
              //     i18n: {
              //       key: `OrderService.CancelOrderButtonLabel`,
              //     },
              //   },
              // },
              // {
              //   icon: <DoneAllIcon />,
              //   onClick: () => {
              //     this.setState({
              //       i18nSection: `OrderConfirmation`,
              //       openConfirmDialog: true,
              //     });
              //   },
              //   show: canConfirmOrder,
              //   tooltip: {
              //     i18n: {
              //       key: `OrderService.ConfirmationOrderButtonLabel`,
              //     },
              //   },
              // },
              {
                icon: (
                  <MuiLink color="inherit">
                    <AddIcon className={classes.icon} />
                  </MuiLink>
                ),
                onClick: () => {
                  actions.uiTriggered({
                    payload: {
                      data: {
                        name: `fabPlaceOrderClick`,
                      },
                    },
                    type: UI_FAB_PLACE_ORDER_CLICK,
                  });
                  history.push(createPlaceOrderPageLink());
                },
                tooltip: {
                  i18n: {
                    data: {},
                    key: `Place An Order`,
                    englishValue: `Place An Order`,
                  },
                },
              },
            ]}
          />
        )}
        <OrderConfirmationDialog
          details={details}
          i18nSection={i18nSection}
          onNoClick={this.onCloseConfirmDialog}
          onYesClick={this.onCloseConfirmDialog}
          open={openConfirmDialog}
          orderKey={currentOrder.orderKey}
          summary={summary}
        />
        <Grid className={cn(classes.footer, classes.textAlignLeft)} item>
          <Footer />
        </Grid>
      </React.Fragment>
    );
  }
}

/** @type {React.ComponentClass<OrderDetailsComponentProps>} */
const OrderDetails = compose(
  withEntries,
  withServices,
  withWidth(),
  withRouter,
  withStyles(themeCreateInjectableStyles(orderDetailsStyles), { withTheme: true }),
  connect(
    () => (state, ownProps) => {
      const { orderId } = ownProps;
      const orderEntitySelector = orderItemSelector(orderId ? orderId.replace(` `, ``) : null);
      return {
        currentOrder: orderEntitySelector(state),
        orderConfirmationDone: orderConfirmationDoneSelector(state),
        orderConfirmationError: orderConfirmationErrorSelector(state),
        orderConfirmed: orderConfirmedSelector(state),
        selectedOrderLoading: ordersSelectedLoadingSelector(state),
        userInfo: userProfileSelector(state),
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...ordersActionCreators,
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderDetailsComponent);

export default OrderDetails;
